import { ApolloQueryResult, gql } from '@apollo/client'

import { client } from '../client'

export type ProductOption = {
  id: number,
  name: string,
}

type GetProductsData = {
  getProducts: ProductOption[],
}

const GET_PRODUCTS_QUERY = gql`
query GetProducts {
  getProducts {
    id
    name
  }
}
`

export const getProducts = async (
): Promise<ApolloQueryResult<GetProductsData>> => {
  return await client.query<GetProductsData>({
    query: GET_PRODUCTS_QUERY,
  })
}
